import { z } from "zod";

export const TermoEpiSchema = z.object({
    idTermoEpi: z.number().int().optional(),
    codigo: z.string().nonempty({ message: "O código é obrigatório." }),
    descricao: z.string().nonempty({ message: "A descrição é obrigatória." }),
    nome: z.string().optional().nullable(),
    ativo: z.coerce.number().default(1),

});

export type TermoEpiForm = z.infer<typeof TermoEpiSchema>;

export const defaultTermoEpiForm: Partial<TermoEpiForm> = {
    idTermoEpi: undefined,
    codigo: undefined,
    descricao: undefined,
    nome: undefined,
    ativo: 1,

};